<div class="ltms-information-panel" [id]="'IINF'+feedId">
    <div class="ltms-information-container">
        <div class="ltms-information-column">
            <div class="ltms-information-column-header">
                <div class="ltms-information-label">Profile</div> 
                <button class="ltms-information-button" *ngIf="isTSEnabled && !isUnTokenisedInfo" (click)="viewUserProfile($event,customerId)" >
                    view
                </button>
            </div>
            <div class="ltms-information-row" *ngFor="let detail of profileDetails">
                <div class="ltms-row-header">{{detail.header}}</div>
                <div class="ltms-row-value" style="word-wrap: break-word;">{{detail.value}}</div>
            </div>
        </div>
        <div class="ltms-information-column">
            <div class="ltms-information-column-header">
                <div class="ltms-information-label">Transaction details</div>
            </div>
            <div class="ltms-information-row" *ngFor="let detail of transactionDetails">
                <div class="ltms-row-header">{{detail.header}}</div>
                <div class="ltms-row-value" [class.show-more]="detail.showMore" [id]="detail.field_id">{{detail.value}}</div>
                <span class="show-more-btn" *ngIf="isEllipsisActive(detail)" (click)="changeFieldView($event,detail)">{{(detail.showMore)?'Show less':'Show more'}}</span>
            </div>
        </div>
        <div class="ltms-information-column">
            <div class="ltms-information-column-header">
                <div class="ltms-information-label">Notification detail</div>
            </div>
            <div class="ltms-information-row" *ngFor="let detail of notifactionDetails">
                <div class="ltms-row-header">{{detail.header}}</div>
                <div class="ltms-row-value">{{detail.value}}</div>
            </div>
        </div>
    </div>

</div>
